import type { LocationGeocodedAddress } from '@carvia/ros-client-types';
import { BookingLocationType } from '@/entities/bookings/booking-location-type.enum';
import type { BookingLocation } from '@/entities/bookings/booking.entity';

export const locationGeocodedAddressToBookingLocation = (
  location: LocationGeocodedAddress | null | undefined,
): BookingLocation | null | undefined => {
  if (!location) return location;
  const { location: coordinates, ...address } = location;
  return {
    locationType: BookingLocationType.STREET,
    station: null,
    location: {
      coordinates,
      address,
    },
  };
};
